import { render, staticRenderFns } from "./PublistTrain.vue?vue&type=template&id=588ea817&scoped=true"
import script from "./PublistTrain.vue?vue&type=script&lang=js"
export * from "./PublistTrain.vue?vue&type=script&lang=js"
import style0 from "./PublistTrain.vue?vue&type=style&index=0&id=588ea817&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588ea817",
  null
  
)

export default component.exports